export const SETTINGS_SCOPE = {
  PREFERENCES: "preferences",
  API_OPTIONS: "apiOptions",
};

export const CELL_COLORS = {
  good: "#7DCEA0",
  medium: "#F7DC6F",
  bad: "#F1948A",
};

export const DAYS = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];

export const DAYS_OF_WEEK = 7;

export const HOURS = [
  "6:30 AM",
  "7:30 AM",
  "8:30 AM",
  "9:30 AM",
  "10:30 AM",
  "11:30 AM",
  "12:30 PM",
  "1:30 PM",
  "2:30 PM",
  "3:30 PM",
  "4:30 PM",
  "5:30 PM",
  "6:30 PM",
  "7:30 PM",
];

export const UNEXPECTED_ERROR_MESSAGE = `
El servidor tardó en responder o un error inesperado ocurrió, por favor vuélvalo
a intentar refrescando la página.
`;
